"use strict";
// A web interface to manage a trail guide mobile app's content and data.
// Copyright (C) 2021-2025  David Lougheed
// See NOTICE for more information.
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_router_dom_1 = require("react-router-dom");
var antd_1 = require("antd");
var config_1 = require("../config");
var hooks_1 = require("../hooks");
var hooks_2 = require("../modules/stations/hooks");
var MODAL_PREFIX = "".concat(config_1.APP_BASE_URL, "/modals/");
var PAGE_PREFIX = "".concat(config_1.APP_BASE_URL, "/pages/");
var STATION_PREFIX = "".concat(config_1.APP_BASE_URL, "/stations/");
var byIdFactory = function (items) { return function () { return Object.fromEntries((items !== null && items !== void 0 ? items : []).map(function (obj) { return [obj.id, obj]; })); }; };
var HTMLContent = react_1.default.memo(function (_a) {
    var id = _a.id, htmlContent = _a.htmlContent;
    var navigate = (0, react_router_dom_1.useNavigate)();
    var modals = (0, hooks_1.useAppSelector)(function (state) { return state.modals.items; });
    var modalsById = (0, react_1.useMemo)(byIdFactory(modals), [modals]);
    var pages = (0, hooks_1.useAppSelector)(function (state) { return state.pages.items; });
    var pagesById = (0, react_1.useMemo)(byIdFactory(pages), [pages]);
    var stations = (0, hooks_2.useStations)().items;
    var stationsById = (0, react_1.useMemo)(byIdFactory(stations), [stations]);
    var _b = (0, react_1.useState)(null), modalShown = _b[0], setModalShown = _b[1];
    var hideModal = (0, react_1.useCallback)(function () { return setModalShown(null); }, []);
    var addHrefHandlers = (0, react_1.useCallback)(function (anchorEl) {
        var href = anchorEl.getAttribute("href");
        if (!href)
            return;
        if (href.startsWith(MODAL_PREFIX)) {
            anchorEl.addEventListener("click", function (e) {
                e.preventDefault();
                var modalId = href.replace(MODAL_PREFIX, "");
                if (modalsById.hasOwnProperty(modalId))
                    setModalShown(modalsById[modalId]);
            });
        }
        else if (href.startsWith(PAGE_PREFIX)) {
            anchorEl.addEventListener("click", function (e) {
                e.preventDefault();
                var pageId = href.replace(PAGE_PREFIX, "");
                if (pagesById.hasOwnProperty(pageId))
                    navigate("/pages/detail/".concat(pageId));
            });
        }
        else if (href.startsWith(STATION_PREFIX)) {
            anchorEl.addEventListener("click", function (e) {
                e.preventDefault();
                var stationId = href.replace(STATION_PREFIX, "");
                if (stationsById.hasOwnProperty(stationId))
                    navigate("/stations/detail/".concat(stationId));
            });
        }
    }, [modalsById, pagesById, stationsById, navigate]);
    (0, react_1.useEffect)(function () {
        if (!htmlContent)
            return;
        document.querySelectorAll("#".concat(id, " a")).forEach(addHrefHandlers);
        if (modalShown)
            document.querySelectorAll("#".concat(id, "-modal a")).forEach(addHrefHandlers);
    }, [htmlContent, addHrefHandlers, modalShown]);
    /** @type React.ReactNode */
    var footer = (0, react_1.useMemo)(function () { return react_1.default.createElement(antd_1.Button, { onClick: hideModal }, modalShown === null || modalShown === void 0 ? void 0 : modalShown.close_text); }, [hideModal, modalShown]);
    var modalContentObj = (0, react_1.useMemo)(function () { return ({ __html: modalShown === null || modalShown === void 0 ? void 0 : modalShown.content }); }, [modalShown]);
    var htmlContentObj = (0, react_1.useMemo)(function () { return ({ __html: htmlContent }); }, [htmlContent]);
    return react_1.default.createElement("div", null,
        react_1.default.createElement(antd_1.Modal, { width: 640, open: modalShown !== null, onCancel: hideModal, title: modalShown === null || modalShown === void 0 ? void 0 : modalShown.title, footer: footer }, modalShown
            ? react_1.default.createElement("div", { className: "html-content", id: "".concat(id, "-modal"), dangerouslySetInnerHTML: modalContentObj })
            : null),
        react_1.default.createElement("div", { className: "html-content", id: id, dangerouslySetInnerHTML: htmlContentObj }));
});
exports.default = HTMLContent;
